import React from "react";
import "./index.css";
import logo from "../assets/logo.svg";
import logoCons from "../assets/logoCons.png";
import { Link } from "react-router-dom";

const Header = () => {
  return (
    <div className="header flex flexCenter flexCol">
      <h3>Volkswagen</h3>

      <div className="logo container flex flexCenter flex">
        <Link to={"/"}>
          <img src={logo} alt="Logo" />
        </Link>
      </div>
    </div>
  );
};

export default Header;
